export default __webpack_public_path__ + "static/media/screen_livechat_04.be4234a0.png";